import shared from '~shared'

export default {
  load(){
    return shared.getRequest().get('/news.json?limit=7')
    .then(result => {
      return result.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/news/server.js